import axios from 'axios'

export default {
  login (data) {
    return axios ({
      method: 'POST',
      url: '/login',
      data: data
    })
  },
  auth(data){
    return axios({
      method: 'POST',
      url: '/api/auth',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  getSearchItems(data) {
    return axios ({
      method: 'GET',
      url: '/api/select_item',
      params: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },

    })
  },
  getOfficialTask(data) {
    return axios ({
      method: 'GET',
      url: '/api/official/task',
      params: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  officialCheck(data) {
    return axios ({
      method: 'POST',
      url: '/api/official/check',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  getTaskList(data) {
    return axios ({
      method: 'GET',
      url: '/api/tasks',
      params: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  getItems(data) {
    return axios ({
      method: 'GET',
      url: '/api/select_items',
      params: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  newTask(data){
    return axios({
      method: 'POST',
      url: '/api/task/add',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  getTask(data) {
    return axios({
      method: 'GET',
      url: '/api/task/'+data.key,
      params: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  editTask(data) {
    return axios ({
      method: 'POST',
      url: '/api/rireki/'+data.key+'/add',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  updateTask(data) {
    return axios ({
      method: 'POST',
      url: '/api/rireki/'+data.key+'/update',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  updateUrgency(data) {
    return axios ({
      method: 'POST',
      url: '/api/urgency/update',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  updateUrgencyList(data) {
    return axios ({
      method: 'POST',
      url: '/api/urgency/updateList',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  addUrgency(data) {
    return axios ({
      method: 'POST',
      url: '/api/urgency/add',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  setLocation(data) {
    return axios ({
      method: 'POST',
      url: '/api/location/edit',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  getMode(data) {
    return axios({
      method: 'GET',
      url: '/api/mode',
      params: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  setMode(data) {
    return axios ({
      method: 'POST',
      url: '/api/mode/edit',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  updateUser(data) {
    return axios ({
      method: 'POST',
      url: '/api/members/edit',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  updateUserList(data) {
    return axios ({
      method: 'POST',
      url: '/api/members/updateList',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  password(data) {
    return axios ({
      method: 'POST',
      url: '/api/pw/reset',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  addUser(data) {
    return axios ({
      method: 'POST',
      url: '/api/members/add',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  getDevice(data) {
    return axios ({
      method: 'GET',
      url: '/api/devices',
      params: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  addDevice(data) {
    return axios ({
      method: 'POST',
      url: '/api/devices/add',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  updateDevice(data) {
    return axios ({
      method: 'POST',
      url: '/api/devices/update',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  getTracking(data) {
    return axios ({
      method: 'GET',
      url: '/api/getTracking',
      params: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
  updateModules(data) {
    return axios ({
      method: 'POST',
      url: '/api/modules/update',
      data: data,
      headers: { 'Authorization' : `Bearer ${data.token}` },
    })
  },
}